<template>
    <div class="single-product__media-feed collection_category">
        <div class="single-product__media-feed-section">
            <div class="left_content">
                <div class="left_content_premium">
                    <h2 class="mb-25px">{{ collectionCategory.title }}</h2>
                    <p class="agp-light">{{ collectionCategory.description }}</p>
                    <!-- {{ collectionCategory.list_item }} -->
                </div>
            </div>
            <div id="media-feed-carousel" class="splide splide--slide splide--ltr splide--draggable is-active is-overflow is-initialized" aria-label="Beautiful Images" role="region" aria-roledescription="carousel">
                <div class="splide__track splide__track--slide splide__track--ltr splide__track--draggable" id="media-feed-carousel-track" style="padding-left: 0px; padding-right: 0px;" aria-live="polite" aria-atomic="true" aria-busy="false">
                    <ul class="splide__list" id="media-feed-carousel-list" role="presentation" style="transform: translateX(0px);">
                        <li v-for="(item, index) in collectionCategory.list_item" :key="index" class="splide__slide is-active is-visible" id="media-feed-carousel-slide01" role="group" aria-roledescription="slide" aria-label="1 of 4" style="margin-right: 12px; width: 47%;">
                            <img height="280px" :src="`${baseUrl}/api/wp-content/uploads/${item.img_item}`"  :data-original_src="`${item.img_item}`">
                            <div class="btn_custom" @click="popupData(collectionCategory.list_item[index])">Shop The Look</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div id="imageModal" v-if="check_modal">
        <div class="modal-overlay" @click="closeModalData()"></div>
        
        <div class="modal-content " :class="{ items_main_custom: item_detail.list_products.length > 1 }"> 
            <span @click="closeModalData()" class="modal-close">×</span>
            <div class="custom_modal">
                <div class="title_mb">
                    <h3>In this Look</h3> </div>
                <div class="left_modal"><img :src="`${baseUrl}/api/wp-content/uploads/${item_detail.img_item}`" alt="Modal Image" class="modal-img"></div>
                <div class="right_modal">
                    <div class="content_right">
                        <h3>In this Look</h3>
                        <div class="main_connte_pr">
                            <div class="item_product" v-for="(item, index) in item_detail.list_products" :key="index" :class="{ item2_product: index === 1 }">
                                <a :href="getLangUrl(item.url, baseUrl, locale)" class="link_product url_pr1"><img :src="`${baseUrl}/api/wp-content/uploads/${item.main_image_url}`" alt="" class="pr_img img1_item"></a>
                                <div class="infor_product">
                                    <a :href="getLangUrl(item.url, baseUrl, locale)" class="link_product custom_title url_pr1">
                                        <p class="cs_title title_pr1" v-html="htmlSpecialcharsDecode(item.title)"></p>
                                    </a>
                                    <p class="cs_price cs_price1"><span class="cs_price_pc price_pr_1">{{ displayCustomPrice(item.price) }}</span><span v-if="Number(item.regular_price) > Number(item.price)" class="cs_regular price_regular1" >U.P.{{ displayCustomPrice(item.regular_price) }}</span></p> 
                                    <a :href="getLangUrl(item.url, baseUrl, locale)" class="link_product url_pr1">View</a> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div> 
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_mediafeed.scss";
    @import "@/assets/scss/components/product/_collection_category.scss";
</style>

<script setup lang="ts">
    import Splide from "@splidejs/splide"
    import { onMounted } from "vue"
    const check_modal = ref();
    const { $ajax } = useNuxtApp();
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const wooStore = useWooStore();
    const countryShort = wooStore.country?.country_short;
    import { displayCustomPrice } from "~/utils/displayPrice";
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    import { getLangUrl } from '~/utils/getLangUrl';
    
    const item_detail = ref<{
        img_item: string;
        list_products: any[];
        } | null>(null);

    const props = defineProps(["data"]);
    const collectionCategory = computed(() => props.data);
    const activeButtons = ref<number[]>([]);
    const isActive = (index: number): boolean => {
        return activeButtons.value.includes(index);
    };

    const popupData = (data) => {
        item_detail.value = data;
        document.body.style.setProperty('overflow-y', 'hidden', 'important');
        check_modal.value = true;
    }
    const closeModalData = () => {
        document.body.style.setProperty('overflow-y', 'auto', 'important');
        check_modal.value = false;
    }
    onMounted(() => {
        altLazyIO();

        const sliderSelector = ".collection_category #media-feed-carousel";
        const sliderElement = document.querySelector(sliderSelector);

        if (!sliderElement) return;

        const totalSlides = sliderElement.querySelectorAll(".splide__slide").length;

        const options = {
            perMove: 1,
            pagination: false,
            lazyLoad: 'sequential',
            gap: 12,
            fixedWidth: '47%',
            focus: 'center',
            drag: 'free',
            perPage: 2,
            arrows: true,
            breakpoints: {
            768: {
                perPage: 1,
                fixedWidth: '70%',
            },
            576: {
                perPage: 1,
            }
            }
        };

        if (totalSlides <= 1) {
            return;
        }

        if (totalSlides === 2) {
            options.arrows = false;
            options.perPage = totalSlides;
            options.fixedWidth = null;
            options.focus = false;
            options.drag = false;
            if (window.innerWidth <= 768) {
                options.arrows = true;
                options.drag = true;
            }
        }

        const mediaFeedCarousel = new Splide(sliderSelector, options);
        mediaFeedCarousel.mount();
    });

</script>